import {DEFAULT_FILTER} from "../../constants";
import axios from "axios";

export default {
    namespaced: true,
    strict: true,
    state: {
        filterLoaded: false,
        filter: DEFAULT_FILTER.filter,
        sort: DEFAULT_FILTER.sort,
    },
    getters: {
        isFilterActive(state) {
            const currentFilter = state.filter;
            const defaultFilter = DEFAULT_FILTER.filter;

            // Simple JSON comparison for arrays/objects
            const modalFiltersActive =
                currentFilter.free !== defaultFilter.free ||
                JSON.stringify(currentFilter.skills) !== JSON.stringify(defaultFilter.skills) ||
                JSON.stringify(currentFilter.certificate_ids) !== JSON.stringify(defaultFilter.certificate_ids) ||
                JSON.stringify(currentFilter.job_ids) !== JSON.stringify(defaultFilter.job_ids) ||
                JSON.stringify(currentFilter.department_ids) !== JSON.stringify(defaultFilter.department_ids) ||
                JSON.stringify(currentFilter.team_ids) !== JSON.stringify(defaultFilter.team_ids);

            return modalFiltersActive;
        },
    },
    mutations: {
        setLoaded(state){
            state.filterLoaded = true;
        },
        setFilterAsDefault(state) {
            state.filter = DEFAULT_FILTER.filter;
            state.sort = DEFAULT_FILTER.sort;
        },
        setFilter(state, filter) {
            state.filter = filter.filter;
            state.sort = filter.sort;
        },
    },
    actions: {
        loadPlanningFilter({commit}) {
            const defaultState = DEFAULT_FILTER;

            return axios.get(route('settings.planning.person-list.get'))
                .then(response => {
                    const savedSettings = response?.data?.settings;
                    let paramsToAssign;

                    if (savedSettings && typeof savedSettings === 'object' && !Array.isArray(savedSettings) && Object.keys(savedSettings).length > 0) {
                        let constructedParams = {
                            filter: { ...defaultState.filter },
                            sort: defaultState.sort
                        };

                        if (savedSettings.sort) {
                            constructedParams.sort = savedSettings.sort;
                        }

                        if (savedSettings.filter && typeof savedSettings.filter === 'object') {
                            for (const key in savedSettings.filter) {
                                if (Object.prototype.hasOwnProperty.call(savedSettings.filter, key) && key !== 'name' && constructedParams.filter.hasOwnProperty(key)) {
                                    constructedParams.filter[key] = savedSettings.filter[key];
                                }
                            }
                        }
                        paramsToAssign = constructedParams;
                    } else {
                        paramsToAssign = defaultState;
                    }

                    commit('setFilter', paramsToAssign);
                })
                .catch(() => {
                    commit('setFilterAsDefault');
                })
                .finally(() => {
                    commit('setLoaded');
                    // this.loading = false;
                    // this.filteredPersons.current_page = 1;
                    // this.filteredPersons.data = [];
                    // this.canLoadMore = true;
                    // this.getFilteredPersons();
                });
        },
        storeFilter({commit, dispatch}, newFilterState){
            commit('setFilter', newFilterState)

            if (newFilterState.saveFilter) {
                const stateToSave = {
                    filter: newFilterState.filter,
                    sort: newFilterState.sort,
                };

                axios.post(route('settings.planning.person-list.post'), stateToSave);
            }
        },
    },

}